module.exports = __webpack_public_path__ + "img/2023-03-25-fusion-extravaganza-banner.6052ac1.jpg";